import React from "react"
import AboutGallery from "../../components/one/AboutGallery"
import AboutInfo from "../../components/one/AboutInfo"
import AboutMap from "../../components/one/AboutMap"
import AboutStaff from "../../components/one/AboutStaff"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/one/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const about = () => (
  <Layout>
    <SEO title={PAGE.title.about} siteTitle="one" />
    <HeadingL title={PAGE.title.about} target="one" />
    <AboutInfo />
    <AboutMap />
    <AboutStaff />
    <AboutGallery />
  </Layout>
)

export default about
